
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/[tickerSymbol]/about",
      function () {
        return require("private-next-pages/us/[tickerSymbol]/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/[tickerSymbol]/about"])
      });
    }
  